import { startApp } from './app/bootstrap';

startApp();
